import React from 'react';
import listIcon from '../assets/svg/list.svg';
import './EmptyList.css';

type EmptyListProps = {
  text: string;
  desc: string;
}

const EmptyList: React.FC<EmptyListProps> = ({ text, desc }) => {
  return (
    <div className="empty-list">
      <img src={listIcon} alt="Empty list logo" />
      <p className="text">{text}</p>
      <p className="description">{desc}</p>
    </div>
  )
}

export default EmptyList;
